import React from 'react';
import { IconButton, InputAdornment, FormControl, FormLabel } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { parse, format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import OperatorSelect from 'src/components/common/OperatorSelect';

import ValidityAdornment from './ValidityAdornment';

const DateBoundMassActionField = ({
  classes,
  fieldConfig,
  onChange,
  removeLine,
  removable,
  onOperatorChange,
  validity,
  isWritable,
}) => {
  const { t } = useTranslation();
  return (
    <FormControl required={fieldConfig.model.mandatory}>
      <div className={classes.fieldContainer}>
        <ValidityAdornment validity={validity} />
        <FormLabel
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
          }}
          component="div"
        >
          {t(`smartmessaging.massAction.filterLabel.${fieldConfig.model.key}`)}
        </FormLabel>
        <div style={{ marginLeft: '16px', marginRight: '16px', display: 'flex' }}>
          <OperatorSelect
            fieldConfig={fieldConfig}
            onChange={onOperatorChange}
            disabled={!isWritable}
          />
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <DatePicker
            closeOnSelect
            slotProps={{
              textField: { style: { flex: 1 } },
              actionBar: {
                actions: [],
              },
            }}
            disabled={!isWritable}
            format="dd/MM/yyyy"
            value={
              (fieldConfig.value &&
                fieldConfig.value.values &&
                fieldConfig.value.values.length &&
                parse(fieldConfig.value.values[0], 'yyyy/MM/dd', new Date())) ||
              null
            }
            onChange={value => {
              const val = [
                format(value, 'yyyy/MM/dd'),
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length > 1 &&
                  fieldConfig.value.values[1]) ||
                  null,
              ];
              onChange(fieldConfig, val);
            }}
          />
          <FormLabel
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '0.875rem',
              margin: '4px',
            }}
            component="div"
          >
            {t('smartmessaging.inputs.AND')}
          </FormLabel>
          <DatePicker
            closeOnSelect
            slotProps={{
              textField: { style: { flex: 1 } },
              actionBar: {
                actions: [],
              },
            }}
            disabled={!isWritable}
            format="dd/MM/yyyy"
            value={
              (fieldConfig.value &&
                fieldConfig.value.values &&
                fieldConfig.value.values.length &&
                parse(fieldConfig.value.values[1], 'yyyy/MM/dd', new Date())) ||
              null
            }
            onChange={value => {
              const val = [
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length > 1 &&
                  fieldConfig.value.values[0]) ||
                  null,
                format(value, 'yyyy/MM/dd'),
              ];
              onChange(fieldConfig, val);
            }}
          />
          {isWritable && removable && (
            <InputAdornment position="start">
              <IconButton aria-label="clear" onClick={() => removeLine(fieldConfig)} size="large">
                <DeleteIcon />
              </IconButton>
            </InputAdornment>
          )}
        </div>
      </div>
    </FormControl>
  );
};

DateBoundMassActionField.propTypes = {
  classes: PropTypes.object.isRequired,
  fieldConfig: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  removeLine: PropTypes.func.isRequired,
  removable: PropTypes.bool.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
  validity: PropTypes.object.isRequired,
  isWritable: PropTypes.bool.isRequired,
};

export default DateBoundMassActionField;
